import React, { Component } from "react";
import { Typography, TextField, Select, MenuItem } from "@material-ui/core";
import "./style.css";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
} from "@material-ui/pickers";

import ComponentTemplate from "../../Utilities/TemplateWrappers/ComponentTemplate";

import MomentUtils from "@date-io/moment";
import { noImg } from "vrcore-dashboard/dist/utilities";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
export default class JobPackIdentifiers extends Component {
    constructor(props) {
        super(props);
        this.state = { profile: props.profile, edit: props.edit };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderTextDescription = (
        label,
        key,
        multiline = false,
        marginStyle = false
    ) => {
        if (this.state.edit) {
            return (
                <div style={{ marginBottom: 30, textAlign: "left" }}>
                    <Typography
                        variant="h6"
                        style={{
                            color: "#0188cc",
                            fontSize: "18px",
                            marginLeft: marginStyle ? "55px" : "0px",
                        }}
                    >
                        {label}
                    </Typography>
                    <TextField
                        disabled={key === "job_type"}
                        rows={multiline ? 2 : 1}
                        rowsMax={multiline ? 4 : 1}
                        multiline={multiline}
                        style={{
                            width: "100%",
                            marginLeft: marginStyle ? "55px" : "0px",
                        }}
                        value={this.state.profile[key]}
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginBottom: 30,
                        textAlign: "left",
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{
                            color: "#0188cc",
                            fontSize: "18px",
                            marginLeft: marginStyle ? "30px" : "0px",
                        }}
                    >
                        {label}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            marginLeft: marginStyle ? "31px" : "0px",
                            minWidth: "170px",
                            maxWidth: "100%",
                            wordBreak: "break-word",
                        }}
                    >
                        {this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    renderText = (label, key, multiline = false, marginStyle = false) => {
        if (this.state.edit) {
            return (
                <div style={{ marginBottom: 30, textAlign: "left" }}>
                    <Typography
                        variant="h6"
                        style={{
                            color: "#0188cc",
                            fontSize: "18px",
                            marginLeft: marginStyle ? "55px" : "0px",
                        }}
                    >
                        {label}
                    </Typography>
                    <TextField
                        disabled={key === "job_type"}
                        rows={multiline ? 2 : 1}
                        rowsMax={multiline ? 4 : 1}
                        multiline={multiline}
                        style={{
                            width: "100%",
                            marginLeft: marginStyle ? "55px" : "0px",
                        }}
                        value={this.state.profile[key]}
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginBottom: 30,
                        textAlign: "left",
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{
                            color: "#0188cc",
                            fontSize: "18px",
                            marginLeft: marginStyle ? "30px" : "0px",
                        }}
                    >
                        {label}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            marginLeft: marginStyle ? "31px" : "0px",
                            minWidth: "170px",
                            maxWidth: "171px",
                            wordBreak: "break-word",
                        }}
                    >
                        {this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    renderDropDown = (label, key, opts) => {
        if (this.state.edit) {
            let val = [];
            if (Array.isArray(this.state.profile[key]) === false) {
                val = [this.state.profile[key]];
            } else val = this.state.profile[key];
            return (
                <div style={{ marginBottom: 30, textAlign: "left" }}>
                    <Typography
                        variant="h6"
                        style={{ color: "#0188cc", fontSize: "18px" }}
                    >
                        {label}:
                    </Typography>
                    <Select
                        multiple
                        style={{ width: "100%" }}
                        value={
                            val || []
                            // ? "N/A"
                            // : this.state.profile[key]

                            // {userProfile.departments || []}
                        }
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    >
                        {opts.map((option) => {
                            return (
                                <MenuItem value={option} key={option}>
                                    {option}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginBottom: 30,
                        textAlign: "left",
                    }}
                >
                    <Typography
                        style={{ color: "#0188cc", fontSize: "18px" }}
                        variant="h6"
                    >
                        {label}:
                    </Typography>
                    <Typography variant="subtitle2">
                        {!this.state.profile[key]
                            ? ""
                            : typeof this.state.profile[key] === "object"
                            ? this.state.profile[key].map((e) => {
                                  return <span>{e + ", "}</span>;
                              })
                            : this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    renderDropDownDepartment = (label, key, opts) => {
        if (this.state.edit) {
            return (
                <div style={{ marginBottom: 30, textAlign: "left" }}>
                    <Typography
                        variant="h6"
                        style={{ color: "#0188cc", fontSize: "18px" }}
                    >
                        {label}:
                    </Typography>
                    <Select
                        // multiple
                        style={{ width: "70%" }}
                        value={
                            this.state.profile[key] === ""
                                ? "N/A"
                                : this.state.profile[key]
                        }
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    >
                        <MenuItem value={null}>No Departments</MenuItem>
                        {opts.map((option) => {
                            return (
                                <MenuItem value={option} key={option}>
                                    {option}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginBottom: 30,
                        textAlign: "left",
                    }}
                >
                    <Typography
                        style={{ color: "#0188cc", fontSize: "18px" }}
                        variant="h6"
                    >
                        {label}:
                    </Typography>
                    <Typography variant="subtitle2">
                        {!this.state.profile[key]
                            ? ""
                            : typeof this.state.profile[key] === "object"
                            ? this.state.profile[key].map((e) => {
                                  return <span>{e + ", "}</span>;
                              })
                            : this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };

    renderDropDownArea = (label, key, opts) => {
        if (this.state.edit) {
            return (
                <div style={{ marginBottom: 30, textAlign: "left" }}>
                    <Typography
                        variant="h6"
                        style={{ color: "#0188cc", fontSize: "18px" }}
                    >
                        {label}:
                    </Typography>
                    <Select
                        // multiple
                        style={{ width: "70%" }}
                        value={
                            this.state.profile[key] === ""
                                ? "N/A"
                                : this.state.profile[key]
                        }
                        onChange={(event) => {
                            this.props.callback(key, event.target.value);
                        }}
                    >
                        <MenuItem value={null}>No Areas</MenuItem>
                        {opts.map((option) => {
                            return (
                                <MenuItem value={option} key={option}>
                                    {option}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginBottom: 30,
                        textAlign: "left",
                    }}
                >
                    <Typography
                        style={{ color: "#0188cc", fontSize: "18px" }}
                        variant="h6"
                    >
                        {label}:
                    </Typography>
                    <Typography variant="subtitle2">
                        {!this.state.profile[key]
                            ? ""
                            : typeof this.state.profile[key] === "object"
                            ? this.state.profile[key].map((e) => {
                                  return <span>{e + ", "}</span>;
                              })
                            : this.state.profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    render() {
        const { profile } = this.state;
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={false}
                label="Jobpack Information"
            >
                <div style={{ padding: 20 }}>
                    <Typography
                        style={{
                            marginBottom: 30,
                            marginRight: "62px",
                            textAlign: "center",
                        }}
                        variant="h6"
                    >
                        {
                            <img
                                alt={"qrcode"}
                                style={{ height: 100, width: 100 }}
                                src={
                                    profile.qr_code_url
                                        ? profile.qr_code_url
                                        : noImg
                                }
                            />
                        }
                    </Typography>
                    <p
                        style={{
                            color: "red",
                            marginTop: "-28px",
                            textAlign: "center",
                        }}
                    >
                        Start Date and End Date are Mandatory for Jobpack
                    </p>
                    <Typography
                        style={{
                            color: "#0188cc",
                            textAlign: "left",
                            marginBottom: "10px",
                        }}
                        variant="h6"
                    >
                        <b>Basic Details</b>
                    </Typography>
                    {this.props.jobType === "jobpack" &&
                        this.renderTextDescription("Job Name", "job_name")}
                    {this.renderTextDescription(
                        "Description Of Works",
                        "description_of_works",
                        true
                    )}
                    <div
                        style={{
                            // justifyContent: this.state.edit ? "" : "space-evenly",
                            marginBottom: 20,
                        }}
                    >
                        {this.state.edit && this.props.jobType === "jobpack" && (
                            <React.Fragment>
                                <Typography
                                    variant="h6"
                                    style={{
                                        color: "#0188cc",
                                        fontSize: "18px",
                                    }}
                                >
                                    Start Date:<font color="red">*</font>
                                </Typography>
                                <DayPickerInput
                                    value={
                                        profile.start_date === "N/A"
                                            ? ""
                                            : profile.start_date
                                    }
                                    placeholder="Select Start Date"
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="DD-MM-YYYY"
                                    onDayChange={(day) => {
                                        this.props.callback(
                                            "start_date",
                                            moment(day).format("DD-MM-YYYY")
                                        );
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    style={{
                                        color: "#0188cc",
                                        fontSize: "18px",
                                        marginTop: "12px",
                                    }}
                                >
                                    End Date:<font color="red">*</font>
                                </Typography>
                                <DayPickerInput
                                    value={
                                        profile.end_date === "N/A"
                                            ? ""
                                            : profile.end_date
                                    }
                                    placeholder="Select End Date"
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="DD-MM-YYYY"
                                    onDayChange={(day) => {
                                        this.props.callback(
                                            "end_date",
                                            moment(day).format("DD-MM-YYYY")
                                        );
                                    }}
                                />
                            </React.Fragment>
                        )}

                        {!this.state.edit && this.props.jobType === "jobpack" && (
                            <React.Fragment>
                                <Typography
                                    variant="h6"
                                    style={{
                                        color: "#0188cc",
                                        fontSize: "18px",
                                    }}
                                >
                                    Start Date<font color="red">*</font>:
                                </Typography>
                                <Typography variant="subtitle2">
                                    {profile.start_date ===
                                    "undefined-undefined-"
                                        ? "N/A"
                                        : profile.start_date}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    style={{
                                        color: "#0188cc",
                                        fontSize: "18px",
                                        marginTop: "12px",
                                    }}
                                >
                                    End Date<font color="red">*</font>:
                                </Typography>
                                <Typography variant="subtitle2">
                                    {profile.end_date === "undefined-undefined-"
                                        ? "N/A"
                                        : profile.end_date}
                                </Typography>
                            </React.Fragment>
                        )}
                    </div>
                    {this.props.jobType === "jobpack" &&
                        this.renderDropDownDepartment(
                            "Department",
                            "departments",
                            this.props.departments || []
                        )}
                    {this.props.jobType === "jobpack" &&
                        this.renderDropDownArea(
                            "Area",
                            "areas",
                            this.props.areas || []
                        )}
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{
                                backgroundColor: "white",
                                borderRadius: "6px",
                                borderTop: "2px solid #0188cc",
                                borderBottom: "2px solid #0188cc",
                            }}
                        >
                            <h6
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bold",
                                    color: "#0188cc",
                                    borderRadius: "6px",
                                    fontSize: "16px",
                                }}
                            >
                                Optional Details:
                            </h6>
                        </ExpansionPanelSummary>
                        <br />
                        {this.props.jobType === "jobpack" &&
                            this.renderDropDown("Job Stage", "job_stage", [
                                "Planning",
                                "Preparation",
                                "Pre-Works",
                                "Works",
                                "Aftercare",
                                "Inspection & Monitoring",
                                "Complete",
                            ])}
                        <div style={{ display: "flex" }}>
                            <div style={{ marginBottom: 20 }}>
                                {this.state.edit &&
                                    this.props.jobType === "jobpack" && (
                                        <React.Fragment>
                                            <Typography
                                                variant="h6"
                                                style={{
                                                    color: "#0188cc",
                                                    fontSize: "18px",
                                                    marginTop: "12px",
                                                }}
                                            >
                                                Start Time:
                                            </Typography>
                                            <div>
                                                <MuiPickersUtilsProvider
                                                    utils={MomentUtils}
                                                >
                                                    {" "}
                                                    <KeyboardTimePicker
                                                        style={{
                                                            width: "175px",
                                                        }}
                                                        margin="normal"
                                                        id="time-picker"
                                                        ampm={false}
                                                        value={moment(
                                                            profile.start_time,
                                                            "HH:mm"
                                                        )}
                                                        onChange={(time) => {
                                                            this.props.callback(
                                                                "start_time",
                                                                moment(
                                                                    time
                                                                ).format(
                                                                    "HH:mm"
                                                                )
                                                            );
                                                        }}
                                                        KeyboardButtonProps={{
                                                            "aria-label":
                                                                "change time",
                                                        }}
                                                        helperText={""}
                                                        error={""}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </React.Fragment>
                                    )}
                                {!this.state.edit &&
                                    this.props.jobType === "jobpack" && (
                                        <React.Fragment>
                                            <Typography
                                                variant="h6"
                                                style={{
                                                    color: "#0188cc",
                                                    fontSize: "18px",
                                                    marginTop: "12px",
                                                }}
                                            >
                                                Start Time: &nbsp;{" "}
                                                <b style={{ color: "black" }}>
                                                    {profile.start_time ===
                                                    "undefined-undefined-"
                                                        ? "N/A"
                                                        : profile.start_time}
                                                </b>
                                            </Typography>
                                        </React.Fragment>
                                    )}
                            </div>
                            <div>
                                {this.state.edit &&
                                    this.props.jobType === "jobpack" && (
                                        <React.Fragment>
                                            <Typography
                                                style={{
                                                    color: "#0188cc",
                                                    fontSize: "18px",
                                                    marginTop: "12px",
                                                    marginLeft: "53px",
                                                }}
                                                variant="h6"
                                            >
                                                <b>End Time:</b>
                                            </Typography>
                                            <div>
                                                <MuiPickersUtilsProvider
                                                    utils={MomentUtils}
                                                >
                                                    {" "}
                                                    <KeyboardTimePicker
                                                        style={{
                                                            width: "175px",
                                                            marginLeft: "55px",
                                                        }}
                                                        margin="normal"
                                                        id="time-picker"
                                                        ampm={false}
                                                        value={moment(
                                                            profile.end_time,
                                                            "HH:mm"
                                                        )}
                                                        onChange={(time) => {
                                                            this.props.callback(
                                                                "end_time",
                                                                moment(
                                                                    time
                                                                ).format(
                                                                    "HH:mm"
                                                                )
                                                            );
                                                        }}
                                                        KeyboardButtonProps={{
                                                            "aria-label":
                                                                "change time",
                                                        }}
                                                        helperText={""}
                                                        error={""}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </React.Fragment>
                                    )}
                                {!this.state.edit &&
                                    this.props.jobType === "jobpack" && (
                                        <React.Fragment>
                                            <Typography
                                                variant="h6"
                                                style={{
                                                    color: "#0188cc",
                                                    fontSize: "18px",
                                                    marginTop: "12px",
                                                    marginLeft: "53px",
                                                }}
                                            >
                                                End Time: &nbsp;{" "}
                                                <b style={{ color: "black" }}>
                                                    {profile.end_time ===
                                                    "undefined-undefined-"
                                                        ? "N/A"
                                                        : profile.end_time}
                                                </b>
                                            </Typography>
                                        </React.Fragment>
                                    )}
                            </div>
                        </div>
                        <br />
                        <div style={{ display: "flex" }}>
                            {this.renderText("Client Name", "client_name")}
                            {this.renderText(
                                "Client Contact No.",
                                "client_contact_no",
                                false,
                                true
                            )}
                        </div>
                        <div style={{ display: "flex" }}>
                            {this.renderText("Contract No.", "contract_no")}
                            {this.renderText(
                                "Quote No.",
                                "quote_no",
                                false,
                                true
                            )}
                        </div>
                        <div style={{ display: "flex" }}>
                            {this.renderText("PSDP", "psdp")}
                            {this.renderText("PSCS", "pscs", false, true)}
                        </div>
                        <div style={{ display: "flex" }}>
                            {this.renderText("Designer", "designer")}
                            {this.renderText(
                                "Contractor",
                                "contractor",
                                false,
                                true
                            )}
                        </div>
                        <div style={{ display: "flex" }}>
                            {this.renderText("Funding ID", "funding_id")}
                            {this.renderText(
                                "Programme Group",
                                "programme_group",
                                false,
                                true
                            )}
                        </div>
                        <div style={{ display: "flex" }}>
                            {this.renderText("TM Type", "tm_type")}
                        </div>
                    </ExpansionPanel>
                </div>
            </ComponentTemplate>
        );
    }
}
